define('modules/page_generator/views/navigation_tabs',['require','exports','module','base/collectionview','./navigation_tab','ldsh!../templates/navigation_tabs'],function(require, exports, module) {
  "use strict";
  
  var CollectionView = require("base/collectionview"),
      NavigationTab = require("./navigation_tab");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/navigation_tabs"),
    tagName: "ul",
    className: "ed-tabs nav nav-tabs",
    itemView: NavigationTab
  });
});

